import styled from 'styled-components'
import Heading from '../components/Heading/Heading'

const VIEW_FIXED_PADDING_TOP_BOTTOM_IN_MOBILE = '15px'
const VIEW_FIXED_PADDING_TOP_BOTTOM_IN_DESKTOP = '45px'
const MAX_WIDTH = '1890px'

const _View = styled.div<{
  isSummaryPreviewExpanded?: boolean
  $insideSummaryPanel?: boolean
}>`
  margin: 0 auto;
  padding: ${VIEW_FIXED_PADDING_TOP_BOTTOM_IN_MOBILE};
  width: 100%;
  max-width: ${MAX_WIDTH};

  @media (min-width: 1200px) {
    padding-top: ${VIEW_FIXED_PADDING_TOP_BOTTOM_IN_DESKTOP};
    padding-bottom: ${VIEW_FIXED_PADDING_TOP_BOTTOM_IN_DESKTOP};
  }

  @media (min-width: 1800px) {
    padding-right: 60px;
    padding-left: 60px;
  }

  @media (min-width: ${MAX_WIDTH}) {
    left: calc(50% - ${MAX_WIDTH} / 2);
  }
`

export const ConfiguratorView = styled(_View)`
  display: flex;
  flex: 1;
  overflow-x: hidden;
  overflow-y: ${(props) => (props.$insideSummaryPanel ? 'auto' : 'hidden')};

  @media (max-width: 1200px) {
    flex-direction: ${(props) => (props.$insideSummaryPanel ? 'column' : 'row')};
  }

  @media (min-width: 1200px) {
    padding: 0;
    gap: 15px;
    & > div:first-child {
      margin: 30px 0px 30px 30px;
    }
    & > div:last-child {
      margin: ${(props) => (props.$insideSummaryPanel ? '0' : '30px 30px 30px 0px')};
    }
  }

  &::after {
    position: absolute;
    top: 0;
    left: calc(50% - 100vw / 2);
    width: 100vw;
    height: 100vh;
    background-color: rgb(60 60 60 / 50%);
    content: ${(props) => (props.isSummaryPreviewExpanded ? '""' : 'none')};
  }

  @keyframes load {
    0%,
    40% {
      transform: translateY(calc(var(--s) / -4));
    }
    60%,
    100% {
      transform: translateY(calc(var(--s) / 4));
    }
  }
`

export const IframeContainer = styled.div<{
  $insideSummaryPanel?: boolean
}>`
  position: relative;
  user-select: none;
  flex: 1;

  > div {
    height: ${(props) => (props.$insideSummaryPanel ? '30vh' : '100%')};

    @media (min-width: 1200px) {
      height: 100%;
    }
  }

  h1 {
    margin-bottom: 20px;
  }

  @media (min-width: 1200px) {
    h1 {
      margin-left: 20px;
      margin-bottom: 30px;
    }
  }

  .iframe-loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .split-cube,
    .text {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .split-cube {
      /* adjust this to control the size */
      --s: 40px;

      @media (min-width: 768px) {
        --s: 100px;
      }

      @media (min-width: 1800px) {
        --s: 150px;
      }

      --_d: calc(0.353 * var(--s)); /* 0.353 = sin(45deg)/2 */
      width: calc(var(--s) + var(--_d));
      aspect-ratio: 1;
      display: flex;
      margin: calc(var(--s) / 3) 0;
      top: 30%;

      @media (min-width: 1800px) {
        top: 40%;
      }

      &::before,
      &::after {
        content: '';
        flex: 1;
        clip-path: polygon(
          var(--_d) 0,
          100% 0,
          100% calc(100% - var(--_d)),
          calc(100% - var(--_d)) 100%,
          0 100%,
          0 var(--_d)
        );
        background: conic-gradient(
          from -90deg at calc(100% - var(--_d)) var(--_d),
          #4f504a 135deg,
          ${(props) => props.theme.palette.primary.main} 0 270deg,
          ${(props) => props.theme.palette.primary.light} 0
        );
        animation: load 1.5s infinite cubic-bezier(0, 0.5, 0.5, 1.8) alternate;
      }

      &::before {
        margin-right: calc(var(--_d) / -2 - 1px);
      }

      &::after {
        margin-left: calc(var(--_d) / -2 - 1px);
        animation-delay: -0.75s;
      }
    }

    .text {
      font-weight: 500;
      font-size: 14px;
      top: 80%;

      @media (min-width: 768px) {
        font-size: 18px;
      }

      @media (min-width: 1800px) {
        font-size: 20px;
        top: 85%;
      }
    }
  }
`

export const ErrorView = styled(_View)`
  display: flex;
  justify-content: center;

  div {
    background-color: #f9f9f9;
    border: 1px solid ${(props) => props.theme.palette.background.main};
    padding: 30px;
    max-width: 600px;

    h1 {
      margin-bottom: 15px;
    }
  }
`

export const SummaryHeader = styled(Heading)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  font-size: 20px;

  @media (min-width: 768px) {
    font-size: 36px;
  }
`
